import { Button, ButtonTypeMap, ExtendButtonBase, IconButton, Tooltip } from '@mui/material'
import { FC, ReactNode } from 'react'

type ShrinkablePropsType = ExtendButtonBase<ButtonTypeMap<{}, 'button'>> & {
  isIconFirst?: boolean
  shrink?: boolean
  icon?: ReactNode
  text?: ReactNode
}

export const ShrinkableButton: FC<ShrinkablePropsType> = ({ icon, text, shrink = false, isIconFirst, ...props }) => {
  if (shrink && icon && text) {
    return (
      <Tooltip title={text}>
        <span>
          <IconButton {...props}>
            {icon}
          </IconButton>
        </span>
      </Tooltip>
    )
  }

  return (
    <Button {...props}>
      {isIconFirst ? <>{icon}{text}</> : <>{text}{icon}</>}
    </Button>
  )
}
